import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  configmanageList: '/configmanage/list', //权限管理 基本配置
  resetpasswd: '/admin/resetpasswd',// 修改密码
  depList: '/bussdep/list',
  getResult :'/aliyunAuditLog/getResultList',
  getMonthBar :'/analysis/month-bar',
  getAliyunAuditStatistics :'/audit/getAliyunAuditStatistics',
}

// 查询业务来源
export function configmanageList (params) {
  return axios({
    url: api.configmanageList,
    method: 'get',
    params: filterData(params),
    func:'查询业务来源'
  })
}

// 修改密码
export function resetpasswd (data) {
  return axios({
    url: api.resetpasswd,
    method: 'post',
    data: filterData(data),
    func:'修改密码',
  })
}

// 查询机构列表
export function depList () {
  return axios({
    url: api.depList,
    method: 'get',
    func:'查询机构列表',
  })
}
// 查询阿里云审核结果
export function getResult (params) {
  return axios({
    url: api.getResult,
    method: 'get',
    params: filterData(params),
    func:'查询阿里云审核结果',

  })
}
// 好像没用到
export function getMonthBar (params) {
  return axios({
    url: api.getMonthBar,
    method: 'get',
    params: filterData(params)
  })
}
// 查询阿里云审核统计
export function getAliyunAuditStatistics (params) {
  return axios({
    url: api.getAliyunAuditStatistics,
    method: 'get',
    params: filterData(params),
    func:'查询阿里云审核数量统计',
  })
}